import { createBrowserRouter, useNavigate } from 'react-router-dom';
import paths from './path';
import myCardsRoutes from '@core/pages/MyCards/routes';
import { ErrorSection } from 'ni-ui-kit/dist/components/errorSection';
import { useTranslation } from 'react-i18next';

const NotFoundPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(paths.home);
  };

  return (
    <ErrorSection
      code="404"
      title={t('shared.pageNotFoundTitle')}
      message={t('shared.pageNotFoundText')}
      onClick={handleClick}
    />
  );
};

const router = createBrowserRouter([
  myCardsRoutes,
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);

export default router;
